<template>
	<th
		ref="th"
		:style="style"
		:data-clickable="clickable"
		:data-hover="hover"
		@mouseover="handleHover"
		@mouseout="handleHover"
	>
		<slot />
	</th>
</template>
<script lang="ts">
import { StyleValue } from "./table-types";
import { defineComponent, PropType } from "vue";

export default defineComponent({
	name: "TableCellHead",

	props: {
		width: {
			type: String,
			default: () => "auto"
		},

		maxWidth: {
			type: String,
			default: () => "auto"
		},

		background: {
			type: String,
			default: () => "var(--gray-600)"
		},

		hover: {
			type: Boolean,
			default: () => false
		},

		clickable: {
			type: Boolean,
			default: () => false
		},

		padding: {
			type: String as PropType<string | null | undefined>,
			default: () => null
		}
	},

	computed: {
		style(): StyleValue {
			const computedStyle: StyleValue = {
				width: this.width,
				maxWidth: this.maxWidth,
				background: this.background
			};
			if (this.padding) {
				computedStyle.padding = this.padding;
			}
			return computedStyle;
		}
	},

	methods: {
		handleHover() {
			if (this.hover) {
				const cellIndex = (this.$refs.th as any).cellIndex;
				const allTds = (this.$refs.th as any)
					.closest("table")
					.querySelectorAll(`td:nth-child(${cellIndex + 1})`);
				allTds.forEach((td: any) => {
					td.classList.toggle("hover");
				});
			}
		}
	}
});
</script>
<style lang="scss">
div.flow-table-component {
	th[data-clickable] {
		cursor: pointer;
	}
	th[data-hover] {
		&:hover {
			background: var(--gray-500) !important;
		}
	}
}
</style>
